import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

export default function ProductCard({ 
  id, 
  title, 
  image, 
  price, 
  description, 
  min_players, 
  max_players, 
  stripe_price_id,
}) {
  const { cartItems, addToCart, removeFromCart } = useCart();
  const navigate = useNavigate();

  // Animation “justAdded”
  const [justAdded, setJustAdded] = useState(false);

  // Vérifie si **ce produit précis** est dans le panier
  const isInCart = cartItems.some(item => item.id === id);


  const handleAddToCart = (e) => {
    e.preventDefault();
    if (!isInCart) {
      addToCart({
        id,
        stripe_price_id,
        title,
        price: parseFloat(price.replace(' €', '')),
        description,
        image,
        quantity: 1,
        min_players,
        max_players,
      });

      setJustAdded(true);
      setTimeout(() => setJustAdded(false), 1500);

      console.log(`Produit ajouté : ${title} (ID: ${id})`);
    }
  };

  const handleRemoveFromCart = (e) => {
    e.preventDefault();
    removeFromCart(id);
  };

  const handleGoToCart = (e) => {
    e.preventDefault();
    navigate('/cart');
  };

  const buttonClass = `cta-button ${isInCart ? "added-to-cart" : ""} ${justAdded ? "pulse" : ""}`;

  return (
    <div className="game-card store-card">
      <img src={image} alt={title} className="product-image" />
      <div className="product-info">
        <h3>{title}</h3>
        <p className="product-description justified-paragraph">{description}</p>
        <span className="product-price">{price} €</span>
      {max_players > 0 && (
          <p className="product-description">Entre {min_players} et {max_players} joueurs.</p>
      )}
        <button 
          className={buttonClass}
          onClick={isInCart ? handleGoToCart : handleAddToCart}
        >
          {isInCart ? "Ajouté au panier" : "Acheter"}
        </button>

        {isInCart && (
          <div style={{ marginTop: "8px", display: "flex", justifyContent: "space-between" }}>
            <button 
              style={{
                background: "transparent",
                color: "#A64343",
                border: "1px solid #A64343",
                borderRadius: "5px",
                padding: "6px 12px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={handleRemoveFromCart}
            >
              Retirer
            </button>

            <button 
              style={{
                background: "#82B29A",
                color: "#1A1A1A",
                border: "none",
                borderRadius: "5px",
                padding: "6px 12px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
              onClick={handleGoToCart}
            >
              Voir le panier
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
